import React from 'react';
import Icon from '../../../components/AppIcon';

const MilestoneCard = ({ milestone }) => {
  const getAchievementDate = () => {
    if (!milestone?.achievedAt) return null;
    const date = new Date(milestone?.achievedAt);
    return date?.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className={`
      bg-card rounded-lg p-20 shadow-elevation-2 hover:shadow-elevation-3 transition-smooth relative overflow-hidden
      ${milestone?.achieved ? 'border-2 border-success' : 'border border-border'}
    `}>
      {milestone?.achieved && (
        <div className="absolute top-0 right-0 w-32 h-32 bg-success/20 rounded-bl-full"></div>
      )}
      
      <div className="flex items-start justify-between mb-12">
        <div 
          className="flex items-center justify-center w-12 h-12 rounded-lg flex-shrink-0"
          style={{ backgroundColor: milestone?.achieved ? 'var(--color-success)15' : 'var(--color-muted)' }}
        >
          <Icon 
            name={milestone?.achieved ? 'CheckCircle2' : 'Circle'} 
            size={24} 
            color={milestone?.achieved ? 'var(--color-success)' : 'var(--color-muted-foreground)'} 
            strokeWidth={2.5} 
          />
        </div>
        {milestone?.achieved && (
          <div className="flex items-center gap-4 px-8 py-4 bg-success/10 rounded-full">
            <Icon name="Award" size={14} color="var(--color-success)" />
            <span className="text-xs font-semibold text-success">Achieved</span>
          </div>
        )}
      </div>

      <h4 className="text-base font-heading font-semibold text-card-foreground mb-8">
        {milestone?.milestoneName}
      </h4>

      <p className="text-sm text-muted-foreground mb-12">
        {milestone?.milestoneType === 'percentage' 
          ? `${milestone?.milestoneValue}% of target`
          : `$${milestone?.milestoneValue?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
        }
      </p>

      {milestone?.achieved && milestone?.achievedAt && (
        <div className="mb-12 p-10 bg-success/10 rounded-lg">
          <div className="flex items-center gap-6 mb-4">
            <Icon name="Calendar" size={12} color="var(--color-success)" />
            <p className="text-xs font-semibold text-success">Completed</p>
          </div>
          <p className="text-xs text-success">
            {getAchievementDate()}
          </p>
        </div>
      )}

      {milestone?.rewardMessage && (
        <div className={`
          mt-12 p-12 rounded-lg text-xs
          ${milestone?.achieved 
            ? 'bg-success/10 text-success border border-success/20' :'bg-muted text-muted-foreground border border-border'
          }
        `}>
          <div className="flex items-start gap-6">
            <Icon name="Gift" size={12} color={milestone?.achieved ? 'var(--color-success)' : 'var(--color-muted-foreground)'} className="flex-shrink-0 mt-2" />
            <span>{milestone?.rewardMessage}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MilestoneCard;